// extracted by mini-css-extract-plugin
export default {"previewEmail":"EmailPreview_previewEmail__UuwNa","previewEmailBox":"EmailPreview_previewEmailBox__AgGO8"};